import { FC } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormHelperText,
  Typography,
} from '@mui/material';
import { Text } from '@concepta/react-material-ui';

export enum ContactMethod {
  SMS = 1,
  WHATSAPP = 2,
}

interface Props {
  value: ContactMethod | undefined;
  onChange: (method: ContactMethod) => void;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  isInternationalPhone?: boolean;
}

const ContactMethodToggle: FC<Props> = ({
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  isInternationalPhone = false,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value, 10);
    onChange(newValue);
  };

  return (
    <FormControl fullWidth error={!!error}>
      <Box sx={{ mb: 2 }}>
        <FormLabel
          component="legend"
          sx={{
            fontSize: '1rem',
            color: error ? 'error.main' : 'text.primary',
            mb: 1,
            display: 'block',
          }}
        >
          Preferred Contact Method
          {required && (
            <Text fontSize={12} display="inline" sx={{ ml: 0.5 }}>
              (required)
            </Text>
          )}
        </FormLabel>

        <RadioGroup
          row
          value={value?.toString() || ''}
          onChange={handleChange}
          name="preferred-contact-method"
        >
          <FormControlLabel
            value={ContactMethod.SMS.toString()}
            control={<Radio />}
            label="Text Message (SMS)"
            disabled={disabled || isInternationalPhone}
          />
          <FormControlLabel
            value={ContactMethod.WHATSAPP.toString()}
            control={<Radio />}
            label="WhatsApp"
            disabled={disabled}
          />
        </RadioGroup>

        <Typography
          variant="body2"
          sx={{
            mt: 1,
            fontStyle: 'italic',
            color: 'text.secondary',
            fontSize: '0.875rem',
          }}
        >
          Kingdom Strollers only send SMS to US based phone numbers.
        </Typography>

        {error && <FormHelperText sx={{ mt: 1 }}>{error}</FormHelperText>}
      </Box>
    </FormControl>
  );
};

export default ContactMethodToggle;
